import React, { useEffect, useMemo, useRef } from 'react';
import { useLoader } from "react-three-fiber";
import * as THREE from 'three';
import { getPositionTop, getRowByLength, imageHeight, imageWidth, rowWidth } from "../../utils/qui-sommes-nous";

const Image = ({ image, id, viewSize, index, setActiveModal }) => {
	const uniforms = useRef(new THREE.Uniform(new THREE.Vector2(0, 0)));

	const { width, height, x, y } = useMemo(() => {
		const width = viewSize.height * imageWidth;
		const height = viewSize.height * imageHeight;
		const row = getRowByLength(index + 1);
		const y = -getPositionTop(index) * viewSize.height;
		const x = (row - 1) * rowWidth * viewSize.height;
		return { width, height, x, y }
	}, [viewSize, index]);

	useEffect(() => {
		uniforms.current.value.set(width, height);
		uniforms.current.needsUpdate = true;
	}, [image, width, height]);

	const texture = useLoader(THREE.TextureLoader, image.src);

	useEffect(() => {
		// simulate object-fit cover
		const defaultAspectRatio = imageWidth / imageHeight;
		const imageAspectRatio = texture.image.naturalWidth / texture.image.naturalHeight;
		texture.wrapS = THREE.ClampToEdgeWrapping;
		texture.wrapT = THREE.ClampToEdgeWrapping;
		if (imageAspectRatio > defaultAspectRatio) {
			const repeatX = defaultAspectRatio / imageAspectRatio;
			const repeatY = 1;
			texture.repeat.set(repeatX, repeatY);
			texture.offset.setX((1 - repeatX) / 2);
		} else {
			const repeatY = imageAspectRatio / defaultAspectRatio;
			const repeatX = 1;
			texture.repeat.set(repeatX, repeatY);
			texture.offset.setY((1 - repeatY) / 2);
		}
	}, [texture]);

	return (
		<mesh
			onClick={() => void setActiveModal(id)}
			position={[x, y, 0]}
		>
			<planeBufferGeometry attach="geometry" args={[width, height, 1, 1]}/>
			<meshBasicMaterial attach="material" args={[{
				map: texture
			}]}
			/>
		</mesh>
	)
};

export default Image;